import { useReducer } from 'react'
import { recordsReducer } from '../recordsReducer'
import { DataForm, StateForm } from '../types'
import moment from 'moment'

export const useRegisters = () => {
  const [registers, setRecords] = useReducer(recordsReducer, {})

  const initializerRecords = (registers: { [formId: string]: DataForm }) => {
    setRecords({
      type: 'initializer',
      payload: registers,
    })
  }

  const saveRecord = (form: DataForm) => {
    setRecords({
      type: 'saveRecord',
      payload: form,
    })
  }

  const changeStateForm = (values: { id: string; stateForm: StateForm }[]) => {
    setRecords({
      type: 'changeStates',
      payload: values,
    })
  }

  const deleteRecords = async (ids: string[]) => {
    if (ids.length === 0) return
    setRecords({
      type: 'deleteRecords',
      payload: ids,
    })
  }

  const getDataByState = (state: null | StateForm) => {
    const today = moment()
    const sevenDaysAgo = moment().subtract(7, 'days')

    const withinRange = Object.values(registers).filter((item) => {
      if (!item.date) return false

      const itemDate = moment(item.date, 'DD-MM-YYYY')
      const withinDateRange = itemDate.isBetween(sevenDaysAgo, today, null, '[]')

      if (state !== null) {
        return withinDateRange && item.stateForm === state
      }
      return withinDateRange
    })

    return withinRange.sort((a, b) => {
      const [dayA, monthA, yearA] = a.date!.split('-').map(Number)
      const [hoursA, minutesA] = a.time!.split(':').map(Number)

      const [dayB, monthB, yearB] = b.date!.split('-').map(Number)
      const [hoursB, minutesB] = b.time!.split(':').map(Number)

      const dateTimeA = new Date(yearA!, monthA! - 1, dayA, hoursA, minutesA)
      const dateTimeB = new Date(yearB!, monthB! - 1, dayB, hoursB, minutesB)

      return dateTimeB.getTime() - dateTimeA.getTime()
    })
  }
  const deleteObsoleteRecords = () => {
    const sevenDaysAgo = moment().subtract(7, 'days')
    const obsoleteRecords = Object.values(registers).filter((item) => {
      if (!item.date) return false

      const itemDate = moment(item.date, 'DD-MM-YYYY')
      return itemDate.isBefore(sevenDaysAgo)
    })
    deleteRecords(obsoleteRecords.map((item) => item.formId!))
  }

  const getRecordById = (id: string): DataForm => registers[id]!

  return {
    registers,
    saveRecord,
    changeStateForm,
    deleteRecords,
    initializerRecords,
    getDataByState,
    deleteObsoleteRecords,
    getRecordById,
  }
}
